import React, { useState } from "react";
import "./sideBar.css";
import { Link } from "react-router-dom";
const SideBarChat = () => {
  const [show,setShow]=useState(false)
  return (
    <>
        {
      show?(    <span
        style={{
          position: "absolute",
          height: "80%",
          left: "95%",
          width: "50px",
          display: "flex",
          flexDirection: "column-reverse",
          zIndex: "10"
        }}
      >
        <Link to={"/admin/company/chat"}>
          <span className="userPop">
            <span className="messageNotification">
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "white",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                1
              </p>
            </span>
            <img
              style={{
                width: "100%",
                aspectRatio: "1/1"
              }}
              src="https://ps.w.org/user-avatar-reloaded/assets/icon-256x256.png?rev=2540745"
            />
  
            <p>Animateur</p>
          </span>
        </Link>
      </span>):""
    }
    </>


  );
};

export default SideBarChat;
